const allAccordionItems = document.querySelectorAll('.accordion__item');
const allAccordionHeadings = document.querySelectorAll('.accordion__heading');

allAccordionHeadings.forEach((heading) => {
  heading.addEventListener('click', () => {
    if (!heading.parentElement.hasAttribute('open')) {
      allAccordionItems.forEach((item) => item.removeAttribute('open'));
    }
  });
});
